import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";

const VideoPlayer = () => {
  const videoUrl = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("videoUrl");
  }, []);

  return (
    <View style={styles.container}>
      <video
        src={videoUrl}
        controls
        autoPlay
        playsInline
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "black",
        }}
      />
    </View>
  );
};

export default VideoPlayer;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "black",
  },
});